const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    // web-vitals v6 (upgraded from v2.1.4 — see package.json). The old
    // getFID/getCLS/... function names are gone entirely: v3 renamed every
    // metric function to onX (onCLS, onFCP, onLCP, onTTFB) and FID itself
    // was retired as a Core Web Vital in March 2024 (removed from Chrome,
    // PageSpeed Insights and CrUX), replaced by INP (onINP) — verified
    // against the current web-vitals README (npm view web-vitals@6.2.3
    // readme) just before this change, not from memory. Without this, the
    // project was collecting zero real interactivity data: getFID simply
    // doesn't exist in any web-vitals version this app could realistically
    // run.
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onINP(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
